import {Model} from "mobx-rest/lib";

export class UxConfigAsList extends Model {
    constructor(props, attributes) {
        super(Object.assign({}, attributes));
    }

    urlRoot() {
        return '/uxDataTableEditorConfig/uxConfigAsList';
    }

    url() {
        return this.urlRoot();
    }

}